/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=cf816e5c&scoped=true&"
import script from "./balance.vue?vue&type=script&lang=js&"
export * from "./balance.vue?vue&type=script&lang=js&"
import style0 from "./balance.vue?vue&type=style&index=0&id=cf816e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf816e5c",
  null
  
)

export default component.exports